import RestService from '../services/rest';

const getVersionApp = async () => RestService.postAuthenticated('settings/detailVersion');
const getSettingsBeehost = async () => RestService.getAuthenticated('settings/beehost');
const getBeeWikiHost = async () => RestService.getAuthenticated('settings/beeWikiHost');
const updateApkClientName = async (apkClientName) => RestService.putAuthenticated(
  'settings/update/apkClientName',
  { apkClientName },
);
const getApkDownloadQr = async () => RestService.postAuthenticated('settings/apkDownloadQr');

export default {
  getVersionApp,
  getSettingsBeehost,
  getBeeWikiHost,
  updateApkClientName,
  getApkDownloadQr,
};
